






































































import Vue from "vue";
export default Vue.extend({
  name: "v-select",
  props: {
    id: {
      type: String as StringConstructor,
      required: true as boolean,
      default: "" as string
    },
    value: {
      type: [String, Object],
      required: true as boolean
    },
    options: {
      type: Array as () => Array<string | { label: string }>,
      required: true as boolean,
      default: () => [] as []
    },
    title: {
      type: String as () => string,
      required: false as boolean,
      default: "" as string
    },
    searchable: {
      type: Boolean as () => boolean,
      required: false as boolean,
      default: false as boolean
    },
    searchPlaceholder: {
      type: String as () => string,
      required: false as boolean
    },
    focusIndication: {
      type: Boolean as () => boolean,
      required: false as boolean
    }
  },
  data: () => {
    return {
      search: "" as string,
      selected: "" as string | object,
      open: false as boolean,
      focusCounter: 0 as number
    };
  },
  computed: {
    filteredOptions() {
      if (!this.search) {
        return this.options;
      } else {
        return this.options.filter(item =>
          typeof item === "object"
            ? item.label
            : item
                .toString()
                .toLowerCase()
                .includes(this.search.toLowerCase())
        );
      }
    }
  },
  methods: {
    handleCloseOptions() {
      this.open = false;
      this.search = "";
      this.focusCounter = 0;
    },

    handleKeyDown(type: string, selection: string | object): void {
      switch (type) {
        case "toggleOptions":
          if (document.activeElement?.id !== "search") {
            this.open = !this.open;
            this.focusCounter = 0;
            this.searchable
              ? ((this.focusCounter -= 1), this.focusToRef("search"))
              : this.validateOptionsArray()
              ? this.focusToRef("option", this.focusCounter)
              : null;
          }
          break;
        case "keyDown":
          if (this.focusCounter < this.options.length - 1) {
            this.focusCounter += 1;
            this.validateOptionsArray()
              ? this.focusToRef("option", this.focusCounter)
              : null;
          }
          break;
        case "keyUp":
          if (this.focusCounter > -1) {
            this.focusCounter -= 1;
            this.focusCounter < 0
              ? this.searchable
                ? this.focusToRef("search")
                : null
              : this.validateOptionsArray()
              ? this.focusToRef("option", this.focusCounter)
              : null;
          }
          break;
        case "esc":
          this.handleCloseOptions();
          this.focusToRef("selected");
          this.$emit("input", this.selected);
          break;
        case "optionSpace":
        case "optionEnter":
          this.selected = selection;
          this.handleCloseOptions();
          this.focusToRef("selected");
          this.$emit("input", this.selected);
          break;
        default:
          break;
      }
    },

    validateOptionsArray(): boolean {
      return Array.isArray(this.filteredOptions) && this.filteredOptions.length
        ? true
        : false;
    },

    handleKeyDownTab(event: KeyboardEvent, type: string): void {
      switch (type) {
        case "tab":
          if (this.focusCounter < this.options.length - 1) {
            this.focusCounter += 1;
            this.focusCounter < 0
              ? this.searchable
                ? this.focusCounter === -1
                  ? this.focusToRef("search")
                  : null
                : null
              : this.validateOptionsArray()
              ? this.focusToRef("option", this.focusCounter)
              : null;
          }
          event.preventDefault();
          break;
        case "shift-tab":
          if (this.focusCounter > (this.controlsHidden() ? -1 : -2)) {
            this.focusCounter -= 1;
            this.focusCounter < 0
              ? this.searchable
                ? this.focusCounter === -1
                  ? this.focusToRef("search")
                  : this.focusToRef("close")
                : this.focusToRef("close")
              : this.validateOptionsArray()
              ? this.focusToRef("option", this.focusCounter)
              : null;
          }
          event.preventDefault();
          break;
        default:
          break;
      }
    },

    handleClick(type: string, selection: string | object): void {
      switch (type) {
        case "toggleOptions":
          this.open = !this.open;
          this.focusCounter = 0;
          this.searchable
            ? ((this.focusCounter -= 1), this.focusToRef("search"))
            : this.validateOptionsArray()
            ? this.focusToRef("option", this.focusCounter)
            : null;
          break;
        case "selectOption":
          this.selected = selection;
          this.handleCloseOptions();
          this.focusToRef("selected");
          this.$emit("input", this.selected);
          break;
        default:
          break;
      }
    },

    handleInputChange(event: { target: HTMLInputElement }): void {
      this.search = event.target.value;
      this.filteredOptions = this.options.filter(
        obj => obj !== event.target.value
      );
    },

    controlsHidden() {
      const computedStyle = window.getComputedStyle(
        document.querySelector(".v--options--controls") as HTMLElement
      );
      return computedStyle.display === "none";
    },

    focusToRef(type: string, index?: number): void {
      switch (type) {
        case "selected":
          this.$nextTick(() => {
            (this.$refs.selected as (Vue | Element | Vue[] | Element[]) & {
              focus: () => boolean;
            })?.focus();
          });
          break;
        case "close":
          this.$nextTick(() => {
            (this.$refs.close as (Vue | Element | Vue[] | Element[]) & {
              focus: () => boolean;
            })?.focus();
          });
          break;
        case "search":
          this.$nextTick(() => {
            (this.$refs.search as (Vue | Element | Vue[] | Element[]) & {
              focus: () => boolean;
            })?.focus();
          });
          break;
        case "option":
          this.$nextTick(() => {
            ((this.$refs.options as Vue & {
              [key: number]: Vue | Element | Vue[] | Element[];
            })[index as number] as HTMLElement)?.focus();
          });
          break;
        default:
          break;
      }
    }
  },
  mounted() {
    this.$emit("input", this.$props.value);
  }
});
